import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';

/** Default interval between pings in seconds */
export const DEFAULT_INTERVAL = 10;

/** Default number of pings must be skipped before mark converter as offline */
export const DEFAULT_TIMEOUT_AFTER = 3;

/** Converter ping settings - DTO signature */
export interface ConverterPingSettingsInterface {
  /** Interval between pings in seconds ({@link DEFAULT_INTERVAL} by default) */
  interval?: number;
  /** How many pings must be skipped before mark converter as offline ({@link DEFAULT_INTERVAL} by default) */
  timeoutAfter?: number;
}

/** Converter ping settings - DTO schema */
export const ConverterPingSettingsDto = SerdeDtoClass.create<ConverterPingSettingsInterface>(PacsDtoKeysEnum.CONVERTER_PING_SETTINGS_DTO, {
  interval: {
    optional: true,
    default: DEFAULT_INTERVAL,
    label: 'Интервал пинга (сек.)',
    hint: 'Определяет интервал в секундах, через который устройство обращается к ФРМ',
    serializer: idLikeSchema,
  },
  timeoutAfter: {
    optional: true,
    default: DEFAULT_TIMEOUT_AFTER,
    label: 'Считать офлайн через',
    hint: 'Определяет количество "пропущенных" обращений к ФРМ, после которого устройство переходит в состояние "Офлайн"',
    serializer: idLikeSchema,
  },
});
